import {StapleFoodEntity} from "../config/StapleFoodConfig";
import {BUNDLE_SMALL_NAME, getOneBundleByInstant} from "../../../BundleResourceConfig";
import O1HD from "../../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 * 食物 超类
 */
@ccclass
export default class FoodItem extends cc.Component {

    @property({type:cc.Node,displayName:"其他节点"})
    otherNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"黄金盘子"})
    goldPlate : cc.Node = null;
    @property({type:sp.Skeleton,displayName:""})
    efChangeSp : sp.Skeleton = null;
    @property(cc.Node)
    normalNode : cc.Node = null;

    private mStapleFoodEntity : StapleFoodEntity;

    onLoad () {
        O1HD.on("FoodItem.addFoodMaterial" , this.addFoodMaterial , this );
        O1HD.on("FoodItem.takeAway" , this.takeAway , this );
        O1HD.on("FoodItem.serveFood" , this.serveFood , this );
        O1HD.on( "FoodItem.goldPlate" , this.changGoldPlate , this );
        O1HD.on("FoodItem.transformation" , this.transformation , this );
    }

    start () {

    }

    bindData( stapleFoodEntity : StapleFoodEntity ){
        this.mStapleFoodEntity = stapleFoodEntity;
    }

    /**
     * 添加菜品
     * @param goodsId
     */
    addFoodMaterial( goodsId : number ){

    }

    /**
     * 变成金盘子
     */
    changGoldPlate(){
        if ( this.node ) {
            console.log("变身金盘子")
            this.goldPlate.active = true;
        }
    }

    /**
     * 变身
     */
    transformation( typeName : string ){
        //
    }

    /**
     * 上菜
     */
    serveFood(){
        if( this.node ){
            cc.tween( this.node )
                .to( 0.5,{ x : 0 } )
                .call(()=>{

                })
                .start();
        }
    }

    //移除
    takeAway(){
        if ( this.node ) {
            cc.tween( this.node )
                .by( 1,{ x : -800 } )
                .call(()=>{
                    this.node.removeFromParent();
                    this.node.destroy();
                })
                .start();
        }
    }


    // 激活 数组节点
    protected _activeItem( nodeArray : cc.Node[] ,imgPath ?: string ){
        for ( let i = 0 ; i < nodeArray.length ; i ++ ){
            if ( nodeArray[i].active == false ) {
                nodeArray[i].active = true;
                if ( imgPath ) {
                    let bundle = getOneBundleByInstant( BUNDLE_SMALL_NAME.setUpShopGameBundle );
                    bundle.load( `assets/goods/${imgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame ) => {
                        if ( error ) {
                            console.error("摆盘 图片出错" , imgPath );
                        }
                        nodeArray[i].getComponent( cc.Sprite ).spriteFrame = assets;
                    });
                }
                break;
            }
        }
    }
}
